import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { HttpClientPort } from '../core/http/http-client.port';
import { CategoryRepository } from '../domain/repositories/category.repository';
import { PopulationRepository } from '../domain/repositories/population.repository';
import { TourismResourceRepository } from '../domain/repositories/tourism-resource.repository';
import { TranslationRepository } from '../domain/repositories/translation.repository';
import { ZoneRepository } from '../domain/repositories/zone.repository';

import { AngularHttpClient } from './http/angular-http.client';
import { AssetTranslationRepository } from './repositories/asset-translation.repository';
import { HttpCategoryRepository } from './repositories/http-category.repository';
import { HttpPopulationRepository } from './repositories/http-population.repository';
import { HttpTourismResourceRepository } from './repositories/http-tourism-resource.repository';
import { HttpZoneRepository } from './repositories/http-zone.repository';

export function provideDataLayer(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: HttpClientPort, useClass: AngularHttpClient },
    { provide: TourismResourceRepository, useClass: HttpTourismResourceRepository },
    { provide: CategoryRepository, useClass: HttpCategoryRepository },
    { provide: ZoneRepository, useClass: HttpZoneRepository },
    { provide: PopulationRepository, useClass: HttpPopulationRepository },
    { provide: TranslationRepository, useClass: AssetTranslationRepository },
  ]);
}
